import { render, staticRenderFns } from "./PostsPage.vue?vue&type=template&id=4d32ce90&scoped=true&"
import script from "./PostsPage.vue?vue&type=script&lang=js&"
export * from "./PostsPage.vue?vue&type=script&lang=js&"
import style0 from "./PostsPage.vue?vue&type=style&index=0&id=4d32ce90&lang=scss&scoped=true&"
import style1 from "./PostsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d32ce90",
  null
  
)

export default component.exports